export default [
    {
        title: 'Dashboard',
        route: 'company.dashboard',
        icon: 'home',
    },

    {
        title: 'Onboarding',
        route: 'formations',
        icon: 'add-paper',
    },

    {
        title: 'Compliance',
        icon: 'compliance-logo',

        children: [
            {
                title: 'ACRA List',
                route: 'compliance.acra-list',
                icon: 'ban-company-icon',
            },
            
            {
                title: 'MAS List',
                route: 'compliance.mas-list',
                icon: 'ban-company-icon',
            },

            {
                title: ' MAS Screening',
                route: 'compliance.mas-screening',
                icon: 'document-screening-icon',
            },
        ]
    },

    {
        title: 'New Requirements',
        icon: 'list-plus',

        children: [
            {
                title: 'RONS',
                route: 'new-requirements.rons',
                icon: 'mail-rons',
            },
        ]
    },

    {
        title: 'User',
        icon: 'users',
        route: 'userManagement',
    },
   
    {
        title: 'Disbursement',
        icon: 'dollar',
    },
    {
        title: 'Setup',
        icon: 'setting',
        children: [
            {
                title: 'Share Type',
                route: 'share-type',
                icon: 'grid',
            },
            {
                title: 'Secretary Firm',
                route: 'secretary-firm',
                icon: 'secretary_firm',
            },
            {
                title: 'Secretary',
                route: 'secretary',
                icon: 'female_x5F_chinese',
            },
            {
                title: 'Operating Hours',
                route: 'operating-hours',
                icon: 'clock',
            },
            {
                title: 'Fee',
                route: 'fee',
                icon: 'dollar',
            },
            {
                title: 'Nominee Director',
                route: 'nominee-director',
                icon: 'director'
            },
            {
                title: 'Auditor',
                route: 'auditor',
                icon: 'auditor',
            },
            {
                title: 'Officer',
                route: 'officer',
                icon: 'officer',
            },
        ]
    },

    // {
    //     title: 'Download Center',
    //     route: 'download-center',
    //     icon: 'download',
    // },
];
